<template>
  <Form
    ref="formInline"
    :model="params"
    inline
  >
    <FormItem
      v-for="(item, index) in searchItems"
      :key="index"
    >
      <Input
        v-if="item.type == 'input'"
        v-model="params[item.name]"
        :placeholder="'请输入' + item.label"
      ></Input>
      <DatePicker
        v-if="item.type == 'date'"
        :value="params[item.name]"
        type="date"
        confirm
        :placeholder="'请选择' + item.label"
        format="yyyy-MM-dd"
        @on-change="params[item.name] = $event"
      ></DatePicker>
      <Select
        v-if="item.type == 'select'"
        v-model="params[item.name]"
        style="width:180px"
        :placeholder="'请选择' + item.label"
      >
        <Option
          v-for="(sitem,i) in item.data"
          :key="sitem.value+i"
          :value="sitem.value"
        >
          {{ sitem.label }}
        </Option>
      </Select>
    </FormItem>
    <Button
      type="primary"
      icon="ios-search"
      @click="handleSubmit()"
    >
      搜索
    </Button>
    <slot name="btn"></slot>
  </Form>
</template>
<script>
export default {
  props: ['searchItems'],
  data() {
    return {
      params: {
        startTime: ''
      },
    };
  },
  mounted() {
    this.searchItems.map(ele => {
      if (ele.today) {
        this.params[ele.name] = ele.today ? ele.today : '';
      }
    });

    // console.log(new Date())
  },
  methods: {
    async handleSubmit() {
      this.$emit('handle-search', this.params);
    },
  },
};
</script>



// WEBPACK FOOTER //
// node_modules/@sditest/electronic-invoice-api/src/components/electronicInvoiceApi/searchForm.vue